import * as React from "react";
import { useEffect } from "react";
import * as esignService from "../../../service/esign/esignService";
import { asyncGetServiceRequest } from "../../../service/postLogin/clientProfileAPIService";

export const VerficationStage = (props: any) => {
  //const [loader, setLoader] = React.useState(false);
  const [esignButton, setEsignButton] = React.useState(true);
  const [childSrList, setChildSrList] = React.useState<any>();
  const [parentSr, setParentSr] = React.useState<any>();
  useEffect(() => {
    asyncGetServiceRequest()
      .then((res) => {
        setParentSr(
          res.filter(
            (srReq: any) =>
              srReq.RequestType === "Equity Dormant Reactivation" &&
              ["PendingForEsign"].includes(srReq.RequestStatus)
          )[0]
        );
      })
      .catch((err) => {
        apiError();
      });
    if (!parentSr) {
      const interval = setInterval(() => {
        asyncGetServiceRequest()
          .then((res) => {
            setParentSr(
              res.filter(
                (srReq: any) =>
                  srReq.RequestType === "Equity Dormant Reactivation" &&
                  ["PendingForEsign"].includes(srReq.RequestStatus)
              )[0]
            );
            if (parentSr) clearInterval(interval);
          })
          .catch((err) => {
            apiError();
          });
      }, 1000 * 30);
    }

    asyncGetServiceRequest(props.srId)
      .then((list) => {
        setChildSrList(list);
      })
      .catch((err) => {
        apiError();
      });
  }, []);
  function apiError() {
    props.onSubmit("createRequestApiError", {
      content:
        "There was some problem in raising service request. Please try again later.",
      headerText: "New Service Request",
    });
  }
  const clearLocalStorage = () => {
    window.localStorage.removeItem("digie");
    window.localStorage.removeItem("digieResubmit");
    window.localStorage.removeItem("rejectFlow");
    window.localStorage.removeItem("srId");
    window.localStorage.removeItem("");
  };
  const StatusList = () => {
    let profile = false;

    if (childSrList && childSrList.length > 0) {
      let esign: boolean = true;
      const list = childSrList.map((sr: any) => {
        switch (sr.RequestType) {
          case "FATCA Declaration":
          case "Income Declaration":
          case "Email and Phone Update":
            esign = esign && sr.RequestStatus === "Approved";
            let fatca,
              income,
              email = false;
            if (sr.RequestType === "FATCA Declaration") {
              esign = esign && sr.RequestStatus === "Approved";
              fatca = true;
            }
            if (sr.RequestType === "Income Declaration") {
              esign = esign && sr.RequestStatus === "Approved";
              income = true;
            }
            if (!profile) {
              esign = esign && sr.RequestStatus === "Approved";
              profile = true;

              return (
                <div className="eSignWrap__block display-flex align-center content-space-between">
                  <div>
                    <h4>Profile Details</h4>
                  </div>
                  <div>
                    <a
                      href={
                        sr.RequestStatus === "Rejected - Resubmit"
                          ? "?rejected&source=ajs"
                          : undefined
                      }
                    >
                      <h4
                        className={
                          sr.RequestStatus === "Approved"
                            ? "green_text "
                            : sr.RequestStatus === "Rejected - Resubmit"
                            ? "red_text"
                            : "orange_text " + "noBoldText"
                        }
                      >
                        {" "}
                        {sr.RequestStatus === "Approved"
                          ? "Completed"
                          : sr.RequestStatus === "Rejected - Resubmit"
                          ? "Rejected"
                          : "Pending"}
                      </h4>
                      <div className="rejection-reason">
                        {sr.creator_remarks &&
                          (sr.RequestStatus === "Rejected - Resubmit" ||
                            sr.RequestStatus === "Rejected") &&
                          sr.RequestStatus === "Rejected - Resubmit" && (
                            <div className="special-text-wrap">
                              <p className="special-text">
                                <div className="redCircleBg">
                                  {/* <i className="edel-icon-faqs"></i> */}
                                  <i className="edel-icon-rejection-reason"></i>
                                </div>
                                <span className="special-text__tooltip">
                                  <span className="bold-text">
                                    Rejection reasons
                                  </span>
                                  <span>
                                    <br />
                                    {sr.creator_remarks}
                                  </span>
                                </span>
                              </p>
                            </div>
                          )}
                      </div>
                    </a>
                  </div>
                </div>
              );
            } else {
              return;
            }
          case "CKYC Update":
            esign = esign && sr.RequestStatus === "Approved";
            return (
              <div className="eSignWrap__block display-flex align-center content-space-between">
                <div className="display-flex align-center">
                  <h4>CKYC Update</h4>
                  <div className="rejection-reason">
                    {sr.creator_remarks &&
                      (sr.RequestStatus === "Rejected - Resubmit" ||
                        sr.RequestStatus === "Rejected") &&
                      sr.RequestStatus === "Rejected - Resubmit" && (
                        <div className="special-text-wrap">
                          <p className="special-text">
                            <div className="redCircleBg">
                              {/* <i className="edel-icon-faqs"></i> */}
                              <i className="edel-icon-rejection-reason"></i>
                            </div>
                            <span className="special-text__tooltip">
                              <span className="bold-text">
                                Rejection reasons
                              </span>
                              <span>
                                <br />
                                {sr.creator_remarks}
                              </span>
                            </span>
                          </p>
                        </div>
                      )}
                  </div>
                </div>

                <div>
                  <a
                    href={
                      sr.RequestStatus === "Rejected - Resubmit"
                        ? "?rejected&source=ajs"
                        : undefined
                    }
                  >
                    <h4
                      className={
                        sr.RequestStatus === "PendingforEsign" ||
                        sr.RequestStatus === "Approved"
                          ? "green_text "
                          : sr.RequestStatus === "Rejected - Resubmit"
                          ? "red_text"
                          : "orange_text " + "noBoldText"
                      }
                    >
                      {" "}
                      {sr.RequestStatus === "PendingforEsign" ||
                      sr.RequestStatus === "Approved"
                        ? "Completed"
                        : sr.RequestStatus === "Rejected - Resubmit"
                        ? "Rejected"
                        : "Pending"}
                    </h4>
                  </a>
                </div>
              </div>
            );

          case "Change of Address":
            esign =
              esign &&
              (sr.RequestStatus === "Approved" ||
                sr.RequestStatus === "PendingForEsign");
            return (
              <>
              <div className="eSignWrap__block display-flex align-center content-space-between">
                <div className="display-flex align-center">
                  <h4>Address Details</h4>
                  <div className="rejection-reason">
                    {sr.creator_remarks &&
                      (sr.RequestStatus === "Rejected - Resubmit" ||
                        sr.RequestStatus === "Rejected") &&
                      sr.RequestStatus === "Rejected - Resubmit" && (
                        <div className="special-text-wrap">
                          <p className="special-text">
                            <div className="redCircleBg">
                              {/* <i className="edel-icon-faqs"></i> */}
                              <i className="edel-icon-rejection-reason"></i>
                            </div>
                            <span className="special-text__tooltip">
                              <span className="bold-text">
                                Rejection reasons
                              </span>
                              <span>
                                <br />
                                {sr.creator_remarks}
                              </span>
                            </span>
                          </p>
                        </div>
                      )}
                  </div>
                </div>

                <div>
                  <a
                    href={
                      sr.RequestStatus === "Rejected - Resubmit"
                        ? "?rejected&source=ajs"
                        : undefined
                    }
                    onClick={() => {
                      clearLocalStorage();
                    }}
                  >
                    <h4
                      className={
                        sr.RequestStatus === "PendingforEsign" ||
                        sr.RequestStatus === "Approved"
                          ? "green_text "
                          : sr.RequestStatus === "Rejected - Resubmit"
                          ? "red_text"
                          : "orange_text " + "noBoldText"
                      }
                    >
                      {" "}
                      {sr.RequestStatus === "PendingforEsign" ||
                      sr.RequestStatus === "Approved"
                        ? "Completed"
                        : sr.RequestStatus === "Rejected - Resubmit"
                        ? "Rejected"
                        : "Pending"}
                    </h4>
                  </a>
                </div>
              </div>      
                {/* Status block for Video IPV */}
             { (localStorage.getItem("ipvcode") && localStorage.getItem("imageData")) && <div className="eSignWrap__block display-flex align-center content-space-between">
                <div className="display-flex align-center">
                  <h4>Video IPV</h4>
                  <div className="rejection-reason">
                    {sr.creator_remarks &&
                      (sr.RequestStatus === "Rejected - Resubmit" ||
                        sr.RequestStatus === "Rejected") &&
                      sr.RequestStatus === "Rejected - Resubmit" && (
                        <div className="special-text-wrap">
                          <p className="special-text">
                            <div className="redCircleBg">
                              {/* <i className="edel-icon-faqs"></i> */}
                              <i className="edel-icon-rejection-reason"></i>
                            </div>
                            <span className="special-text__tooltip">
                              <span className="bold-text">
                                Rejection reasons
                              </span>
                              <span>
                                <br />
                                {sr.creator_remarks}
                              </span>
                            </span>
                          </p>
                        </div>
                      )}
                  </div>
                </div>

                <div>
                  <a
                    href={
                      sr.RequestStatus === "Rejected - Resubmit"
                        ? "?rejected&source=ajs"
                        : undefined
                    }
                    onClick={() => {
                      clearLocalStorage();
                    }}
                  >
                    <h4
                      className={
                        sr.RequestStatus === "PendingforEsign" ||
                        sr.RequestStatus === "Approved"
                          ? "green_text "
                          : sr.RequestStatus === "Rejected - Resubmit"
                          ? "red_text"
                          : "orange_text " + "noBoldText"
                      }
                    >
                      {" "}
                      {sr.RequestStatus === "PendingforEsign" ||
                      sr.RequestStatus === "Approved"
                        ? "Completed"
                        : sr.RequestStatus === "Rejected - Resubmit"
                        ? "Rejected"
                        : "Pending"}
                    </h4>
                  </a>
                </div>
              </div> }
              </>
            );
          case "Bank Modification":
            esign = esign && sr.RequestStatus === "Approved";
            return (
              <div className="eSignWrap__block display-flex align-center content-space-between">
                <div className="display-flex align-center">
                  <h4>Bank Details</h4>
                  <div className="rejection-reason">
                    {sr.creator_remarks &&
                      (sr.RequestStatus === "Rejected - Resubmit" ||
                        sr.RequestStatus === "Rejected") && (
                        <div className="special-text-wrap">
                          <p className="special-text">
                            <div className="redCircleBg">
                              {/* <i className="edel-icon-faqs"></i> */}
                              <i className="edel-icon-rejection-reason"></i>
                            </div>
                            <span className="special-text__tooltip">
                              <span className="bold-text">
                                Rejection reasons
                              </span>
                              <span>
                                <br />
                                {sr.creator_remarks}
                              </span>
                            </span>
                          </p>
                        </div>
                      )}
                  </div>
                </div>

                <div>
                  <a
                    href={
                      sr.RequestStatus === "Rejected - Resubmit"
                        ? "?rejected&source=ajs"
                        : undefined
                    }
                  >
                    <h4
                      className={
                        sr.RequestStatus === "PendingforEsign" ||
                        sr.RequestStatus === "Approved"
                          ? "green_text "
                          : sr.RequestStatus === "Rejected - Resubmit"
                          ? "red_text"
                          : "orange_text " + "noBoldText"
                      }
                    >
                      {" "}
                      {sr.RequestStatus === "PendingforEsign" ||
                      sr.RequestStatus === "Approved"
                        ? "Completed"
                        : sr.RequestStatus === "Rejected - Resubmit"
                        ? "Rejected"
                        : "Pending"}
                    </h4>
                  </a>
                </div>
              </div>
            );
        }
      });
      setEsignButton(esign);
      return list;
    } else {
      return false;
    }
  };

  const proceedToEsign = async () => {
    if(parentSr.EsignUrl){
      window.open(parentSr.EsignUrl, "_self");
    } else {
      try {
        props.setLoader(true);
        let result = await esignService.proceedToEsign(
          props.srId,
          "accReact",
          false
        );
      } catch (err) {
        props.setLoader(false);
        openErrorPopup();
      }
    }
  };
  const prefilledEsign = async () => {
    try {
      props.setLoader(true);
      const pdf = await esignService.getPreFilledFormPDF(
        props.srId,
        "accReact"
      );
      const base64 = await esignService.base64toPDF(pdf);
      props.setLoader(false);
    } catch (error) {
      props.setLoader(false);
      openErrorPopup();
    }
  };
  const openErrorPopup = () => {
    props.setLoader(false);
    props.onSubmit("Account Reactivation", {
      headerText: "There was some error while proceeding with esign process.",
    });
  };
  return (
    <>
      {!props.loader && (
        <div className="eSignWrap">
          <div className="custom--row">
          </div>
          <div className="adharSecWrap">
            <h2 className="text-center">Account verification in progress</h2>
            <h4 className="field-subHead text-center">
              We have received your request, it’s under verification and will be
              completed within one working day. After Successful verification we
              will send an email to complete E Sign.
            </h4>
            <div>
              <StatusList />
            </div>
            <p className="text-center note space-mt-3">
              <span className="bold-text">Please note: </span>Once we are done
              with verification, we will intimate to complete esign process.
            </p>
            <div className="proceedEsign">
              <button
                type="button"
                className={
                  (esignButton && parentSr ? false : true)
                    ? "common_button login-btn block_btn light-text"
                    : "common_button login-btn block_btn"
                }
                onClick={() => proceedToEsign()}
                disabled={esignButton && parentSr ? false : true}
              >
                Proceed to E-Sign
              </button>
            </div>
            <div className="button icon-btn">
              <button
                type="button"
                className={
                  !esignButton
                    ? "ed_button common_button"
                    : "ed_button common_button"
                }
                onClick={prefilledEsign}
                // disabled={!esignButton}
              >
                <span className="edel-icon-download"></span>
                <span>Download Pre-filled Form</span>
              </button>
            </div>
            <div className="text">
              <h4 className="reminderText">
                If your mobile and Aadhar are not linked please contact your RM
                Arvind Kathappan
              </h4>
              <h4 className="reminderText">
                Or write to us on{" "}
                <a
                  href="mailto:helpdesk@nuvama.com"
                  className="mail_link bold-text"
                >
                  helpdesk@nuvama.com
                </a>
              </h4>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
